module.exports = __webpack_public_path__ + "img/android-app-icon-step-1.64b70d6c.png";